var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, EventEmitter, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { ViewToolsMode } from '../../models/view-tools-mode.enum';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { ViewService } from '../../view.service';
import { Fullscreen } from 'src/app/shared/libraries/fullscreen/fullscreen';
import { ViewState } from '../../state/view.state';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';
import { ViewActions } from '../../state/view.actions';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { takeUntil } from 'rxjs/operators';
export class ViewToolsComponent {
    // ---------- Lifecycle Events ----------
    constructor(viewService, layoutService, store, changeDetectorRef) {
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Class Variables ----------
        this.viewToolsMode = ViewToolsMode;
        this.viewLayout = ViewLayout;
        this.canFullscreen = true;
        this.isFullscreen = false;
        this.toolEnum = ToolEnum;
        this.ngUnsubscribe = new Subject();
        // ---------- Input / Output ----------
        this.animate = true;
        this._mode = ViewToolsMode.Main;
        this.modeChange = new EventEmitter();
    }
    get mode() {
        return this._mode;
    }
    set mode(value) {
        this._mode = value;
    }
    ngOnInit() {
        this.canFullscreen = Fullscreen.canFullscreen();
        this.store
            .select(ViewState.getLayout)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    handleSelectTool(tool) {
        this.viewService.selectTool(tool);
    }
    handleUndoClick() {
        this.viewService.undo();
    }
    handleToggleLabelsClick() {
        this.viewService.toggleLabels();
    }
    handleFullscreenClick() {
        Fullscreen.toggleFullscreen();
        this.isFullscreen = Fullscreen.isFullscreen();
    }
    handleSearchClick() {
        this.viewService.toggleSearch();
    }
    handlePlayClick() {
        this.viewService.toggleAnimation();
    }
    handlePresentClick() {
        this.viewService.togglePresentation();
    }
    handleHelpClick() {
        this.viewService.toggleHelp();
    }
    handleNewTabClick() {
        this.viewService.openInNewTab();
    }
    toggleToolbar(bar) {
        const layout = this.store.selectSnapshot(ViewState.getLayout);
        layout.media.status = ViewLayoutStatus.Hide;
        layout.tools.status = ViewLayoutStatus.Hide;
        layout.toolbar.status = ViewLayoutStatus.Hide;
        layout[bar].status = ViewLayoutStatus.Show;
        this.store.dispatch(new ViewActions.SetLayout(layout));
    }
    isEnabled(layout) {
        return this.layoutService.isLayoutEnabled(layout);
    }
}
__decorate([
    Select(EngineState.getActiveTool),
    __metadata("design:type", Observable)
], ViewToolsComponent.prototype, "activeTool$", void 0);
__decorate([
    Select(ViewState.getPresentationActive),
    __metadata("design:type", Observable)
], ViewToolsComponent.prototype, "presentationActive$", void 0);
__decorate([
    Select(StoryChaptersState.getIsChapterAnimated),
    __metadata("design:type", Observable)
], ViewToolsComponent.prototype, "isChapterAnimated$", void 0);
__decorate([
    Select(EngineState.getShowLabels),
    __metadata("design:type", Observable)
], ViewToolsComponent.prototype, "showLabels$", void 0);
__decorate([
    Select(EngineState.getAnimationPlaying),
    __metadata("design:type", Observable)
], ViewToolsComponent.prototype, "animationPlaying$", void 0);
__decorate([
    Select(StoryLabelsState.getChapterLabels),
    __metadata("design:type", Observable)
], ViewToolsComponent.prototype, "labels$", void 0);
__decorate([
    Select(StoryChaptersState.getChapterCount),
    __metadata("design:type", Observable)
], ViewToolsComponent.prototype, "chapterCount$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterAudio),
    __metadata("design:type", Observable)
], ViewToolsComponent.prototype, "selectedChapterAudio$", void 0);
